import script from "./ViewInsight.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewInsight.vue?vue&type=script&setup=true&lang=js"

import "./ViewInsight.vue?vue&type=style&index=0&id=38b41b38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b41b38"]])

export default __exports__